import _classCallCheck from '/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass';
import _inherits from '/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits';
import _createSuper from '/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createSuper';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module horizontal-line/horizontallineediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import HorizontalLineCommand from './horizontallinecommand';
import { toWidget } from '@ckeditor/ckeditor5-widget/src/utils';
import '../theme/horizontalline.css';
/**
 * The horizontal line editing feature.
 *
 * @extends module:core/plugin~Plugin
 */
var HorizontalLineEditing = /*#__PURE__*/
function (_Plugin) {
    _inherits(HorizontalLineEditing, _Plugin);
    var _super = _createSuper(HorizontalLineEditing);
    function HorizontalLineEditing() {
        _classCallCheck(this, HorizontalLineEditing);
        return _super.apply(this, arguments);
    }
    _createClass(HorizontalLineEditing, [{
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var editor = this.editor;
                var schema = editor.model.schema;
                var t = editor.t;
                var conversion = editor.conversion;
                schema.register('horizontalLine', {
                    isObject: true,
                    allowWhere: '$block'
                });
                conversion.for('dataDowncast').elementToElement({
                    model: 'horizontalLine',
                    view: function view(modelElement, viewWriter) {
                        return viewWriter.createEmptyElement('hr');
                    }
                });
                conversion.for('editingDowncast').elementToElement({
                    model: 'horizontalLine',
                    view: function view(modelElement, viewWriter) {
                        var label = t('Горизонтальная линия');
                        var viewWrapper = viewWriter.createContainerElement('div');
                        var viewHrElement = viewWriter.createEmptyElement('hr');
                        viewWriter.addClass('ck-horizontal-line', viewWrapper);
                        viewWriter.setCustomProperty('hr', true, viewWrapper);
                        viewWriter.insert(viewWriter.createPositionAt(viewWrapper, 0), viewHrElement);
                        return toHorizontalLineWidget(viewWrapper, viewWriter, label);
                    }
                });
                conversion.for('upcast').elementToElement({
                    view: 'hr',
                    model: 'horizontalLine'
                });
                editor.commands.add('horizontalLine', new HorizontalLineCommand(editor));
            }
        }], [{
            key: 'pluginName',
            /**
     * @inheritDoc
     */
            get: function get() {
                return 'HorizontalLineEditing';
            }
        }]);
    return HorizontalLineEditing;
}(Plugin);
// Converts a given {@link module:engine/view/element~Element} to a horizontal line widget:
// * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to
//   recognize the horizontal line widget element.
// * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
//
//  @param {module:engine/view/element~Element} viewElement
//  @param {module:engine/view/downcastwriter~DowncastWriter} writer An instance of the view writer.
//  @param {String} label The element's label.
//  @returns {module:engine/view/element~Element}
export {
    HorizontalLineEditing as default
};
function toHorizontalLineWidget(viewElement, writer, label) {
    writer.setCustomProperty('horizontalLine', true, viewElement);
    return toWidget(viewElement, writer, { label: label });
}